// extracted by mini-css-extract-plugin
export var drawerLinks = "index-module--drawerLinks--2UZAm";
export var linkLight = "index-module--linkLight--PYP_m";
export var linkDark = "index-module--linkDark--3kCnh";
export var activeLink = "index-module--activeLink--3kAhK";